import React, { useEffect, useState } from "react";
import httpService from "../../../services/http/products/product.service";
import { useParams } from "react-router-dom";
import UnlimitBreadcrumb from "../../../components/ui-kit/unlimit-breadcrumb";
import UnlimitStepper from "../../../components/ui-kit/unlimit-stepper";
import ProductStep1 from "./product-step1";
import ProductStep2 from "./product-step2";
import { useTranslation } from "react-i18next";

const ProductForm = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState(new FormData());
  const [activeStep, setActiveStep] = useState(0);
  const [existingData, setExistingData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  // Fetching product data
  const fetchPredefinedValues = async () => {
    if (id) {
      await getProduct();
    }
  };

  useEffect(() => {
    fetchPredefinedValues();
  }, [id]);

  // Fetch product data by ID
  const getProduct = async () => {
    setIsLoading(true);
    await httpService.getProduct(id)
      .then(async (response) => {
        if (response && response.status === 200) {
          const data = response.data.data;
          setExistingData(data);
        }
      })
      .catch((err) => {
        console.log("Error fetching product:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const breadcrumbItems = [
    { label: "", link: "/", icon: "feather-home" },
    { label: t('product.product'), link: "/product-list" },
  ];

  if (activeStep === 0) {
    breadcrumbItems.push({ label: t('general.general'), active: true });
  } else if (activeStep === 1) {
    breadcrumbItems.push({ label: t('product.productImages'), active: true });
  }

  const steps = [
    { title: t('general.general'), component: ProductStep1 },
    { title: t('product.productImages'), component: ProductStep2 },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex flex-column">
            <div className="page-title">
              <h3 className="text-black">{id ? t('product.editProduct') : t('product.addProduct')}</h3>
            </div>
            <UnlimitBreadcrumb items={breadcrumbItems} />
          </div>
        </div>
        <UnlimitStepper
          steps={steps}
          setActiveStep={setActiveStep}
          formData={formData}
          setFormData={setFormData}
          activeStep={activeStep}
          id={id}
          existingData={existingData}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default ProductForm;